import React from 'react';
import { Sparkles } from 'lucide-react';

interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  centered?: boolean;
  darkMode?: boolean;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ 
  eyebrow, 
  title, 
  subtitle, 
  centered = true,
  darkMode = false 
}) => {
  return (
    <div className={`mb-16 ${centered ? 'text-center' : ''}`}>
      {eyebrow && (
        <p className={`text-sm uppercase tracking-widest mb-4 ${darkMode ? 'text-primary-gold' : 'text-primary-gold'}`}>
          {eyebrow}
        </p>
      )}
      <h2 className={`text-4xl md:text-5xl font-bold mb-4 font-display ${darkMode ? 'text-white' : 'text-gray-900'}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`text-lg md:text-xl max-w-3xl ${centered ? 'mx-auto' : ''} ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
          {subtitle}
        </p>
      )}
      {centered && (
        <div className="flex justify-center mt-6">
          <div className="flex items-center space-x-2">
            <div className={`h-px w-16 ${darkMode ? 'bg-primary-gold' : 'bg-primary-gold'}`}></div>
            <Sparkles className="w-5 h-5 text-primary-gold" />
            <div className={`h-px w-16 ${darkMode ? 'bg-primary-gold' : 'bg-primary-gold'}`}></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SectionHeader;
